import jQuery from 'jquery';
window.$=window.jQuery=jQuery;

import Vue from 'vue';

import NewsList from './NewsList.vue';
Vue.component("NewsList", NewsList);
import AgencyList from './AgencyList.vue';
Vue.component("AgencyList", AgencyList);
import DestList from './DestList.vue';
Vue.component("DestList", DestList);
import ExpList from './ExpList.vue';
Vue.component("ExpList", ExpList);
import HotelList from './HotelList.vue';
Vue.component("HotelList", HotelList);
import VenueList from './VenueList.vue';
Vue.component("VenueList", VenueList);

var detectTouchSwipe=function(el, linkNext, linkPrev) {
  var startPoint=null;
  var endPoint=null;
  var treshold=40;
  $(el).on("touchstart", function(e) {
    if (e.originalEvent.touches.length==1) {
      startPoint=[e.originalEvent.touches[0].clientX,
                  e.originalEvent.touches[0].clientY];
    }
  });
  $(el).on("touchmove", function(e) {
    if (e.originalEvent.touches.length==1) {
      endPoint=[e.originalEvent.touches[0].clientX,
                e.originalEvent.touches[0].clientY];
    }
  });
  $(el).on("touchend", function(e) {
    if (e.originalEvent.touches.length!=0)
      return;
    if (!startPoint || !endPoint)
      return;
    var angle=Math.abs(endPoint[0]-startPoint[0])>Math.abs(endPoint[1]-startPoint[1]);
    if (endPoint[0]<startPoint[0]-treshold && angle)
      $(linkNext).click();
    if (endPoint[0]>startPoint[0]+treshold && angle)
      $(linkPrev).click();
    startPoint=null;
    endPoint=null;
  });
};


// animations
window.scrollAnimations=function($container) {
  var selector=[
    ".content-carousel", ".rainbow-logo", [".box-cont-holder", 2],
    ".news-cont", ".selected-news-cont",
    ".text-page .center-content>*",
    ".list-page .center-content>*",
    ".gal-items li",
    ".boxed-list li",
    ".dest-list li",
    ".exp-head",
    ".text-page .rating",
    ".text-page .loc",
    ".text-page .props>.prop",
    ".contact-form h2",
    ".contact-form .gf-row", 
    ".lp-filters",
  ];
  
  var animElements=$(selector.join(", "), $container || document);
  var animOffsets=null;
  var animQueue=[];
  var $window=$(window);

  var doAnimate=(el)=>{
    el.addClass("animating");
    setTimeout(()=>{
      el.addClass("animated");
    }, 800);
  };
  var animNext=()=>{
    setTimeout(()=>{
      if (animQueue.length) {
        doAnimate(animQueue[0]);
        var nextTimeout=1;
        animQueue.shift()
        setTimeout(()=>{
          animNext();
        }, nextTimeout);
      }
    }, 200);
  };
  var queueAnimate=(el)=>{
    animQueue.push(el);
    if (animQueue.length==1)
      animNext();
  };

  var recalcAnimOffsets=()=>{
    animOffsets=[];
    for(var i=0;i<animElements.length;i++) {
      var element=animElements.eq(i);
      //var top=element.css("top").replace("auto", "").replace("px", "") || 0;
      animOffsets[i]=element.offset().top;
    }
    $window.trigger("scroll.animate");
  }

  recalcAnimOffsets();
  $window.on("load", function() {
    recalcAnimOffsets();
  });

  $window.on("scroll.animate", function(e) {
    var currentOffset=$window.scrollTop();
    for(var i=0;i<animElements.length;i++) {
      var el=animElements.eq(i);
      var offset=animOffsets[i];
      if (offset<currentOffset+window.innerHeight*.9) {
        if (!el.data("animated"))
          queueAnimate(el);
        el.data("animated", true);
      }
    }
  }).trigger("scroll.animate");
  
  
}
$(()=>scrollAnimations());

// common elements
$(function($) {
  $(".to-top a").click(function(e) {
    e.preventDefault();
    $("html,body").animate({scrollTop: 0}, 300);
  });
  $(".lang-menu").click(function(e) {
    if ($(this).hasClass("open"))
      return;
    e.preventDefault();
    $(this).addClass("open");
  });
  $(".mobile-handle").click(function(e) {
    e.preventDefault();
    var wasOpen=$(".mobile-handle").hasClass("open");
    if (!wasOpen) {
      $(".heading-cont").addClass("open");
      $(".mobile-handle").addClass("open");
      $(".selection-cont").addClass("open");
      setTimeout(()=>{
        var els=$(".selection-cont>div")
        var height=els.eq(0).innerHeight()+els.eq(1).innerHeight();
        $(".selection-cont").css("height", height);
      }, 30);
    } else {
      $(".mobile-handle").removeClass("open");
      $(".selection-cont").css("height", 0);
      setTimeout(()=>{
        $(".heading-cont").removeClass("open");
        $(".selection-cont").removeClass("open")
      }, 300);
    }
  });
});

// header scroll
$(function($) {
  $(window).on("scroll.header", function() {
    if ($(window).scrollTop()>50)
      $(".header-container").addClass("scrolled");
    else
      $(".header-container").removeClass("scrolled");
  }).trigger("scroll.header");
});

// gallery
$(function($) {
  $(".gal-container").each(function() {
    var $this=$(this);
    var nav=$this.find(".gal-nav a");
    var index=0;
    var ct=$this.find(".gal-items");
    var items=$this.find(".gal-items>ul>li");
    var visibleCount=function() {
      return window.innerWidth<760?1:2;
    }
    var updatePos=function(newPos) {
      index=newPos;
      ct.animate({scrollLeft: items.eq(newPos).position().left+ct.scrollLeft()}, 300);
    }
    detectTouchSwipe($this, nav.eq(1), nav.eq(0));
    nav.click(function(e) {
      e.preventDefault();
      var maxIndex=items.length-visibleCount()+1;
      if ($(this).hasClass("prev"))
        updatePos((index+maxIndex-1)%maxIndex);
      else
        updatePos((index+1)%maxIndex);
    });
  });
});

// intro carousel
$(function($) {
  $(".content-carousel").each(function() {
    var $this=$(this);
    var pos=$(this).find(".select-cou>div");
    var els=$(this).find(".birou-content");
    var index=0;
    pos.click(function(e) {
      e.preventDefault();
      index=pos.index(this);
      updateIndex();
    });
    var updateIndex=function() {
      pos.removeClass("selected").eq(index).addClass("selected");
      els.addClass("carousel-hidden").eq(index).removeClass("carousel-hidden");
      var backgrounds=JSON.parse($this.find(".main-background").attr("data-backgrounds"));
      var bg=encodeURI(backgrounds[index] || "");
      
      $this.find(".main-background").css("background-image", "url(\""+bg+"\")");
    }
    var prev=$("<a />").click(function(e) {
      index=(index+pos.length-1)%pos.length;
      updateIndex();
    }).hide();
    var next=$("<a />").click(function(e) {
      index=(index+1)%pos.length;
      updateIndex();
    }).hide();
    detectTouchSwipe($this, next, prev);
  });
});

// image popups
$(function($) {
  $("img").click(function(e) {
    $(".img-popup").addClass("visible");
    $(".img-popup img").attr("src", $(this).attr("src"));
  });
  $(".img-popup .close").click(function() {
    $(".img-popup").removeClass("visible");
  });
});

// email obfuscation
$(function($) {
  var rot13=function(str) {
    var input     = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var output    = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm';
    var index     = x => input.indexOf(x);
    var translate = x => index(x) > -1 ? output[index(x)] : x;
    return str.split('').map(translate).join('');
  }
  $("a.em-ob").each(function() {
    var html=$(this).html();
    var email=rot13(html.split("").reverse().join(""));
    $(this).html(email);
    $(this).attr("href", "mailto:"+email);
  });
});

// Vue
$(function($) {
  $("[vue-dyn]").each(function() {
    $(this).removeAttr("vue-dyn");
    new Vue({el: this});
  });
});
